
// index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AuthProvider from './contexts/AuthContext'

import './index.css';

// Configuração global do locale para "pt-BR"
if (Intl && Intl.DateTimeFormat) {
  const options = Intl.DateTimeFormat().resolvedOptions();
  if (options.locale !== 'pt-BR') {
    Intl.DateTimeFormat().resolvedOptions = () => ({
      ...options,
      locale: 'pt-BR',
    });
  }
}

console.log(`Idioma configurado: ${Intl.DateTimeFormat().resolvedOptions().locale}`);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //  <React.StrictMode>
  <BrowserRouter>
    <AuthProvider>
      <App/>
    </AuthProvider>
  </BrowserRouter>
//  </React.StrictMode>
);
